var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1955_10546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1955_10546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4246 20.5001C3.2551 20.5001 3.10285 20.4586 2.96785 20.3758C2.83285 20.293 2.72794 20.1837 2.6531 20.0481C2.5751 19.9134 2.53219 19.7676 2.52435 19.6106C2.51652 19.4536 2.55885 19.2981 2.65135 19.1441L11.2121 4.35605C11.3048 4.20205 11.4206 4.08822 11.5596 4.01455C11.6988 3.94089 11.8453 3.90405 11.9991 3.90405C12.1529 3.90405 12.2994 3.94089 12.4386 4.01455C12.5776 4.08822 12.6934 4.20205 12.7861 4.35605L21.3469 19.1441C21.4394 19.2981 21.4814 19.4529 21.4731 19.6086C21.4648 19.7644 21.4221 19.9109 21.3451 20.0481C21.2683 20.1852 21.1629 20.2949 21.0289 20.3771C20.8949 20.4591 20.7431 20.5001 20.5736 20.5001H3.4246ZM4.4491 19.0001H19.5491L11.9991 6.00005L4.4491 19.0001ZM12.5721 17.5731C12.7286 17.4167 12.8069 17.2257 12.8069 17.0001C12.8069 16.7744 12.7286 16.5834 12.5721 16.4271C12.4158 16.2706 12.2248 16.1923 11.9991 16.1923C11.7734 16.1923 11.5824 16.2706 11.4261 16.4271C11.2696 16.5834 11.1914 16.7744 11.1914 17.0001C11.1914 17.2257 11.2696 17.4167 11.4261 17.5731C11.5824 17.7296 11.7734 17.8078 11.9991 17.8078C12.2248 17.8078 12.4158 17.7296 12.5721 17.5731ZM12.5336 14.9768C12.6773 14.833 12.7491 14.6548 12.7491 14.4423V10.9423C12.7491 10.7298 12.6772 10.5517 12.5334 10.4081C12.3895 10.2642 12.2114 10.1923 11.9989 10.1923C11.7862 10.1923 11.6081 10.2642 11.4646 10.4081C11.3209 10.5517 11.2491 10.7298 11.2491 10.9423V14.4423C11.2491 14.6548 11.321 14.833 11.4649 14.9768C11.6087 15.1205 11.7869 15.1923 11.9994 15.1923C12.212 15.1923 12.3901 15.1205 12.5336 14.9768Z",
    fill: "#F2BD32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleIcon);
export default __webpack_public_path__ + "static/media/warning-triangle-icon.93497e66a964ab64be728ac6ce18de77.svg";
export { ForwardRef as ReactComponent };